import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Plus, FileText } from 'lucide-react';

const ScheduleTab = ({
  exams,
  schedules,
  selectedExam,
  onSelectExam,
  onAddSchedule,
  onEnterMarks
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold">Exam Schedule</h2>
          {selectedExam && <p className="text-muted-foreground">{selectedExam.name}</p>}
        </div>
        <div className="flex gap-2">
          <Select value={selectedExam?.id || ''} onValueChange={onSelectExam}>
            <SelectTrigger className="w-[200px]"><SelectValue placeholder="Select Exam" /></SelectTrigger>
            <SelectContent>
              {exams.map(e => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button onClick={onAddSchedule} disabled={!selectedExam}>
            <Plus className="h-4 w-4 mr-2" /> Add Schedule
          </Button>
        </div>
      </div>

      {schedules.length > 0 ? (
        <Card>
          <CardContent className="p-0">
            <table className="w-full">
              <thead className="bg-muted/50">
                <tr>
                  <th className="p-3 text-left">Date</th>
                  <th className="p-3 text-left">Class</th>
                  <th className="p-3 text-left">Subject</th>
                  <th className="p-3 text-left">Time</th>
                  <th className="p-3 text-left">Room</th>
                  <th className="p-3 text-left">Max Marks</th>
                  <th className="p-3 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {schedules.map(s => (
                  <tr key={s.id} className="border-t">
                    <td className="p-3">{s.exam_date}</td>
                    <td className="p-3">{s.class_name}</td>
                    <td className="p-3 font-medium">{s.subject_name}</td>
                    <td className="p-3">{s.start_time} - {s.end_time}</td>
                    <td className="p-3">{s.room_number || '-'}</td>
                    <td className="p-3">{s.max_marks}</td>
                    <td className="p-3">
                      <Button size="sm" variant="outline" onClick={() => onEnterMarks(s.id)}>
                        <FileText className="h-3 w-3 mr-1" /> Enter Marks
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      ) : (
        <Card className="p-8 text-center text-muted-foreground">
          {selectedExam ? 'No schedules added. Click "Add Schedule" to create exam timetable.' : 'Select an exam to view/add schedule.'}
        </Card>
      )}
    </div>
  );
};

export default ScheduleTab;
